import React from 'react'

import { BaseSkeleton } from 'components/Skeleton'

import {
  SkeletonCardBody,
  SkeletonGrid,
  SkeletonLeft,
  SkeletonLessonRow,
  SkeletonLessonRows,
  SkeletonMediaCard,
  SkeletonRight,
  SkeletonSectionCard,
  SkeletonSectionHeader,
  SkeletonStatsGrid,
  SkeletonStatCard,
} from './styled'

export default function CourseDetailsSkeleton() {
  return (
    <SkeletonGrid>
      <SkeletonLeft>
        <SkeletonMediaCard>
          <BaseSkeleton height={420} width="100%" borderRadius={16} />
        </SkeletonMediaCard>

        <SkeletonSectionCard>
          <SkeletonSectionHeader>
            <BaseSkeleton height={18} width={88} />
            <BaseSkeleton height={18} width={92} />
          </SkeletonSectionHeader>

          <SkeletonCardBody>
            <BaseSkeleton height={24} width={140} borderRadius={999} />
            <BaseSkeleton height={40} width="56%" borderRadius={12} />
            <BaseSkeleton height={16} width="34%" />
            <BaseSkeleton height={16} width="92%" />
            <BaseSkeleton height={16} width="90%" />
            <BaseSkeleton height={16} width="78%" />
            <BaseSkeleton height={52} width={220} borderRadius={12} />
          </SkeletonCardBody>
        </SkeletonSectionCard>
      </SkeletonLeft>

      <SkeletonRight>
        <SkeletonStatsGrid>
          {Array.from({ length: 2 }).map((_, index) => (
            <SkeletonStatCard key={index}>
              <BaseSkeleton height={34} width={34} borderRadius={10} />
              <BaseSkeleton height={22} width={index === 0 ? 36 : 54} />
              <BaseSkeleton height={14} width={72} />
            </SkeletonStatCard>
          ))}
        </SkeletonStatsGrid>

        <SkeletonSectionCard>
          <SkeletonSectionHeader>
            <BaseSkeleton height={20} width={148} />
            <BaseSkeleton height={14} width={128} />
          </SkeletonSectionHeader>

          <SkeletonLessonRows>
            {Array.from({ length: 6 }).map((_, index) => (
              <SkeletonLessonRow key={index}>
                <BaseSkeleton height={38} width={38} borderRadius={12} />
                <div>
                  <BaseSkeleton height={16} width={index === 0 ? 168 : 188} />
                  <BaseSkeleton height={13} width={112} />
                </div>
                <BaseSkeleton height={20} width={20} circle />
              </SkeletonLessonRow>
            ))}
          </SkeletonLessonRows>
        </SkeletonSectionCard>

        <SkeletonSectionCard>
          <SkeletonSectionHeader>
            <BaseSkeleton height={20} width={104} />
            <BaseSkeleton height={14} width={148} />
          </SkeletonSectionHeader>

          <SkeletonCardBody>
            <BaseSkeleton height={180} width="100%" borderRadius={12} />
            <BaseSkeleton height={16} width="58%" />
            <BaseSkeleton height={14} width="82%" />
            <BaseSkeleton height={40} width={112} borderRadius={10} />
          </SkeletonCardBody>
        </SkeletonSectionCard>
      </SkeletonRight>
    </SkeletonGrid>
  )
}
